import React from 'react'
import { Segment } from '@sketch/components'
import { TabsContainer } from './WorkspaceIntegrations.styles'

type TabType = 'all' | 'enabled' | 'not-configured'

interface IntegrationTabsProps {
  activeTab: TabType
  onTabChange: (tab: TabType) => void
  totalIntegrations: number
  enabledCount: number
  availableCount: number
}

export const IntegrationTabs: React.FC<IntegrationTabsProps> = ({
  activeTab,
  onTabChange,
  totalIntegrations,
  enabledCount,
  availableCount,
}) => {
  return (
    <TabsContainer>
      <div onClick={() => onTabChange('all')}>
        <Segment
          type="text"
          label={`All Integrations (${totalIntegrations})`}
          active={activeTab === 'all'}
        />
      </div>
      {enabledCount > 0 && (
        <div onClick={() => onTabChange('enabled')}>
          <Segment
            type="text"
            label={`Enabled (${enabledCount})`}
            active={activeTab === 'enabled'}
          />
        </div>
      )}
      {availableCount > 0 && (
        <div onClick={() => onTabChange('not-configured')}>
          <Segment
            type="text"
            label={`Not Configured (${availableCount})`}
            active={activeTab === 'not-configured'}
          />
        </div>
      )}
    </TabsContainer>
  )
}
